import {combineReducers} from 'redux';

import routes from './routes';

export default combineReducers({
  routes
});
